export default "https://lightningbookassetsdev.blob.core.windows.net/lightning-ui/1.46.0/ui/a695d75f98db5261.png"